import { render } from "./Mailing.vue?vue&type=template&id=987a74b8&scoped=true"
import script from "./Mailing.vue?vue&type=script&lang=js"
export * from "./Mailing.vue?vue&type=script&lang=js"

import "./Mailing.vue?vue&type=style&index=0&id=987a74b8&scoped=true&lang=css"

import exportComponent from "/Users/jaspur/Code/online-alv/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-987a74b8"]])

export default __exports__